import differenceInMinutes from "date-fns/differenceInMinutes";
import { dateNow } from "./dateUtils";
export function shouldPasswordlessCallBeSkipped(lastSuccessRequest: Date | number): boolean {
  return !!lastSuccessRequest && !!(differenceInMinutes(dateNow(), lastSuccessRequest) < 3);
}
